var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"answer-block"},[_c('h1',{staticClass:"ada-focus",attrs:{"role":"alert","aria-live":"assertive","tabindex":"0"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('login-form',{attrs:{"return-url":_vm.returnUrl,"by-order":_vm.byOrder}})],1),_vm._v(" "),_c('base-nav-links',{attrs:{"home":"","no-back":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }